import { useTranslation } from 'react-i18next';

export function VisionSection() {
  const { t } = useTranslation();

  const goals = [
    t('about.vision.goals.items.0'),
    t('about.vision.goals.items.1'),
    t('about.vision.goals.items.2'),
    t('about.vision.goals.items.3'),
    t('about.vision.goals.items.4'),
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gray-900">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            {t('about.vision.title')}
          </h2>
          <p className="text-gray-300 text-lg sm:text-xl leading-relaxed max-w-4xl mx-auto">
            {t('about.vision.intro')}
          </p>
        </div>

        {/* Vision Photo */}
        <div className="mb-12">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img 
              src="https://readdy.ai/api/search-image?query=professional%20nutritionist%20preparing%20fresh%20healthy%20colorful%20meal%20ingredients%20on%20modern%20kitchen%20counter%20with%20vegetables%20fruits%20and%20grains%20natural%20lighting%20clean%20minimalist%20aesthetic%20high%20quality%20lifestyle%20photography&width=1200&height=800&seq=about-vision-lifestyle-nutribot&orientation=landscape"
              alt="Person preparing healthy meal with fresh ingredients"
              className="w-full h-auto object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
          </div>
        </div>

        {/* Goals Grid */}
        <div className="mb-12">
          <h3 className="text-2xl sm:text-3xl font-bold text-white text-center mb-8">
            {t('about.vision.goals.title')}
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {goals.map((goal, index) => (
              <div 
                key={index}
                className="flex items-center space-x-4 bg-gray-800 rounded-xl p-6 border border-gray-700 hover:border-yellow-400 transition-ball duration-300"
              >
                <div className="flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-3xl text-yellow-400"></i>
                </div>
                <p className="text-white text-lg font-medium">{goal}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Vision Statement */}
        <div className="text-center">
          <p className="text-gray-300 text-lg sm:text-xl leading-relaxed max-w-4xl mx-auto">
            {t('about.vision.statement')}
          </p>
        </div>
      </div>
    </section>
  );
}
